import { ReactNode } from "react";
import MapMarker from "../../../../../common/components/map/types/map-marker";
import mapMarkerIconFactory from "../../../../../common/components/map/marker/map-marker-icon.factory";
import { OrderOptimizerTaxiListingItemRoute } from "./types/order-optimizer-taxi-listing-item";

const createMapMarker = (
  route: OrderOptimizerTaxiListingItemRoute,
  content?: ReactNode
): MapMarker => {
  const icon = mapMarkerIconFactory.createIcon({
    className: "map_marker standard",
    content: content,
  });

  const marker: MapMarker = {
    coordinate: {
      latitude: route.lat,
      longitude: route.lon,
    },
    icon,
  };

  return marker;
};

const areWaypointsEqual = (
  waypoint1: OrderOptimizerTaxiListingItemRoute,
  waypoint2: OrderOptimizerTaxiListingItemRoute
): boolean => {
  return waypoint1.lat === waypoint2.lat && waypoint1.lon === waypoint2.lon;
};

const createMapMarkers = (
  waypoints: OrderOptimizerTaxiListingItemRoute[]
): MapMarker[] => {
  let mapMarkers: MapMarker[] = [];

  for (const waypoint of waypoints) {
    const allWaypointsOnThisPlace = waypoints
      .map((w, index) => ({ waypoint: w, index: index + 1 }))
      .filter((w) => areWaypointsEqual(w.waypoint, waypoint));

    const signature = allWaypointsOnThisPlace.map((w) => w.index).join("/");

    const newMarker: MapMarker = createMapMarker(waypoint, signature);

    mapMarkers = [...mapMarkers, newMarker];
  }

  return mapMarkers;
};

const orderOptimizerTaxiListingMapMarkersFactory = {
  createMapMarkers,
};

export default orderOptimizerTaxiListingMapMarkersFactory;
